const findShopifyInboxLauncher = async () => {
  for (let attempt = 0; attempt < 20; attempt += 1) {
    const chat =
      document.getElementById('ShopifyChat') ||
      [...document.querySelectorAll('inbox-online-store-chat')].find((element) => element.shadowRoot);
    const launcher = chat?.shadowRoot?.querySelector(
      '[data-spec="toggle-button"], button.chat-toggle, button.chat-app--close-button[aria-expanded="true"]'
    );

    if (launcher) return launcher;

    await new Promise((resolve) => window.setTimeout(resolve, 150));
  }

  return null;
};

class SecuYouFitDialog extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-fit-dialog-open]');
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('[data-fit-dialog-close]');
    this.inboxButton = this.querySelector('[data-shopify-inbox-open]');
    this.inboxStatus = this.querySelector('[data-shopify-inbox-status]');

    if (!this.trigger || !this.dialog || !this.closeButton) return;

    this.trigger.addEventListener('click', this.open);
    this.closeButton.addEventListener('click', this.close);
    this.inboxButton?.addEventListener('click', this.openInbox);
    this.dialog.addEventListener('click', this.handleBackdropClick);
    this.dialog.addEventListener('close', this.handleClose);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.open);
    this.closeButton?.removeEventListener('click', this.close);
    this.inboxButton?.removeEventListener('click', this.openInbox);
    this.dialog?.removeEventListener('click', this.handleBackdropClick);
    this.dialog?.removeEventListener('close', this.handleClose);
  }

  open = () => {
    if (this.dialog.open) return;

    this.hideInboxStatus();
    document.documentElement.setAttribute('scroll-lock', '');
    this.dialog.showModal();
    this.closeButton.focus();
  };

  close = () => {
    this.dialog.close();
  };

  openInbox = async () => {
    if (this.openingInbox) return;

    this.openingInbox = true;
    this.hideInboxStatus();
    this.inboxButton?.setAttribute('aria-busy', 'true');

    const launcher = await findShopifyInboxLauncher();

    this.openingInbox = false;
    this.inboxButton?.removeAttribute('aria-busy');

    if (!launcher) {
      this.inboxStatus?.removeAttribute('hidden');
      this.inboxButton?.focus();
      return;
    }

    if (this.dialog.open) {
      this.skipReturnFocus = true;
      this.dialog.close();
    }

    if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
  };

  hideInboxStatus = () => {
    this.inboxStatus?.setAttribute('hidden', '');
  };

  handleBackdropClick = (event) => {
    if (event.target === this.dialog) this.close();
  };

  handleClose = () => {
    document.documentElement.removeAttribute('scroll-lock');
    if (!this.skipReturnFocus) this.trigger.focus();
    this.skipReturnFocus = false;
  };
}

if (!customElements.get('secuyou-fit-dialog')) {
  customElements.define('secuyou-fit-dialog', SecuYouFitDialog);
}

class SecuYouInboxTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-shopify-inbox-open]');
    this.status = this.querySelector('[data-shopify-inbox-status]');
    this.button?.addEventListener('click', this.openInbox);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.openInbox);
  }

  openInbox = async () => {
    if (this.openingInbox) return;

    this.openingInbox = true;
    this.status?.setAttribute('hidden', '');
    this.button?.setAttribute('aria-busy', 'true');

    const launcher = await findShopifyInboxLauncher();

    this.openingInbox = false;
    this.button?.removeAttribute('aria-busy');

    if (!launcher) {
      this.status?.removeAttribute('hidden');
      this.button?.focus();
      return;
    }

    if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
  };
}

if (!customElements.get('secuyou-inbox-trigger')) {
  customElements.define('secuyou-inbox-trigger', SecuYouInboxTrigger);
}
